import React, { Component } from "react";
import PropTypes from "prop-types";

// material-ui
import { withStyles } from "@material-ui/core/styles";

// custom
import Table from "components/TablePagination";

// styles
import styles from "./styles";

class TemplatesList extends Component {
  static propTypes = {
    classes: PropTypes.object,
    templates: PropTypes.array,
    onSelect: PropTypes.func,
  };

  onSelect(selectedTemplate) {
    const { onSelect } = this.props;
    this.setState({ selectedTemplate });
    if (onSelect) {
      onSelect(selectedTemplate);
    }
  }

  render() {
    const { templates } = this.props;

    return (
      <Table
        data={templates}
        meta={[
          {
            path: "label",
            title: "Label",
            numeric: false,
          },
          {
            path: "code",
            title: "Code",
            numeric: false,
          },
        ]}
        title={"Templates"}
        onRowSelect={this.onSelect.bind(this)}
      />
    );
  }
}

export default withStyles(styles)(TemplatesList);
